import React from "react";
import {Controller} from "react-hook-form";
import {FilterPicker} from "root/s360components/LearningJournal/FilterPicker";
const FormFilterPicker = ( { validate, control, name, values }) =>
{
    return <Controller
        control={control}
        name={name}
        rules={{ required: false, validate: validate}}
        render={({ field: { onChange, value, name, ref },
                     fieldState: { invalid, isTouched, isDirty, error },
                     formState,
                 }) => <FilterPicker initialValue={0} name={name} values={values} onChange={onChange}/>}
    />
}

export default FormFilterPicker ;
